import swal from "sweetalert2";

export function showForceRefresh() {
	return swal.fire({
		title: "Error!",
		html:
			`The current configuration is expired and must be reloaded before you can create a report.
			<br/>
			<br/>
			Please click the refresh button, and try again.`,
		type: "error",
		allowOutsideClick: false,
		allowEscapeKey: false,
		allowEnterKey: false,
		confirmButtonText: "Refresh"
	})
		.then(res => {
			if(!!res) {
				location.reload();
			}
		});
}